import {combineReducers} from 'redux';
import data from './dataReducer';
import views from './viewsReducer';

export default combineReducers({
  views,
  data,
});
